import React from "react"
import {Helmet} from "react-helmet";
import cheerio from "cheerio"
import parse from 'html-react-parser';
import styles from './embedded.module.scss'

class Embedded extends React.Component {
  render(){
    // console.log('Embedded object: '+ JSON.stringify(this.props.object))
    let $ = cheerio.load(this.props.object.html)
    let scriptTags = $('script').toString()
    const tag = parse(scriptTags)
    // console.log('scriptTags '+ typeof tag )
    let HTMLstring
    if ( this.props.object.source === "YouTube"){
      // console.log('youtube object: '+ JSON.stringify(this.props.object))
      HTMLstring =
      <div className={styles.youtubeContainer}>
        <div dangerouslySetInnerHTML={{ __html: this.props.object.html }} />
      </div>
    } else {
      HTMLstring = <div dangerouslySetInnerHTML={{ __html: this.props.object.html }} />
    }

    // let HTMLstring = this.props.object.html.replaceAll('DharmaGothicE', 'Barlow')
    // HTMLstring = HTMLstring.replaceAll('epocapro', 'Barlow')

    return (
      <div className={styles.embedContainer}>
        <Helmet>
          {tag}
        </Helmet>
        {HTMLstring}
      </div>
    )
  }
}

export default Embedded

